@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';
@import '../../constants/spacing.module.less';

@note-font-size: 14px;
@note-line-height: 20px;
@note-text-padding: 6px;
@note-border-thickness: 1px;
@note-label-padding: calc(@note-text-padding + @note-border-thickness);
@note-min-row-height: calc(@note-line-height + (2 * @note-label-padding));
@note-width-padding: 10px;

@note-active-color: @fulfillment-plans--notes--active-text-color;
@note-non-empty-color: @fulfillment-plans--notes--non-empty--background-color;
@note-hover-color: @fulfillment-plans--notes--hover--background-color;

@note-label-color: @fulfillment-plans--notes--label--text-color;

.fulfillment-plan-notes-widget,
.fulfillment-plan-note,
.note-container,
.note-input {
  width: 100%;
}

.note-container {
  display: flex;
}
.fulfillment-plan-notes-widget {
  border-spacing: 0 @space-8;
}
.fulfillment-plan-note-container {
  &:hover > .note-action > button {
    color: @note-active-color;
  }

  &:focus-within > .note-action > button {
    color: @note-active-color;
  }
}

.note-type-label {
  font-size: @note-font-size;
  line-height: @note-line-height;
  white-space: nowrap;
  text-align: right;
  vertical-align: top;
  padding: @note-label-padding @note-width-padding @note-label-padding 0;
  color: @note-label-color;
}

.note-input {
  padding: 0;
}

.note-textarea {
  font-size: @note-font-size;
  line-height: @note-line-height;
  padding: @note-text-padding @note-width-padding;

  &:focus {
    border: solid @note-border-thickness @note-active-color;
  }

  &.has-content:not(&:focus) {
    background-color: @note-non-empty-color;
    border: solid @note-border-thickness @note-non-empty-color;
    cursor: pointer;
  }

  &:hover.has-content:not(&:focus) {
    background-color: @note-hover-color;
    border: solid @note-border-thickness @note-active-color;
  }
}

.note-action {
  vertical-align: text-bottom;
  padding: 0 0 0 @note-width-padding;
}

.pin-button {
  height: @note-min-row-height;
  width: @note-min-row-height;

  border-radius: 6px;
  color: @fulfillment-plans--notes--pin-button--text-color;

  &.pinned {
    color: @note-active-color;
  }

  &:hover,
  &:focus {
    background-color: @note-hover-color;
    color: @note-active-color;

    &.pinned {
      background-color: @note-hover-color;
      color: @note-active-color;
    }
  }

  &:active {
    background-color: @note-non-empty-color;
    color: @fulfillment-plans--default--text-color;
  }
}

.pin-icon {
  height: 12px;
}
